<div class="relative flex items-center gap-2">
  @if (showUpload()) {
    <p-menu
      #menuCommand
      [model]="items"
      [popup]="true"
      styleClass="z-[1020]"
      appendTo="body"
    >
      <ng-template
        pTemplate="item"
        let-item
      >
        <a
          class="flex align-items-start p-menuitem-link"
          pRipple
        >
          <i [ngClass]="item.icon + ' menu-item-icon text-base text-neutral-200'"></i>
          <div class="flex flex-col align-item-center">
            <span class="ml-2 menu-item-name">{{ item.label }}</span>
            <span class="ml-2 menu-item-details">{{ item.description }}</span>
          </div>
        </a>
      </ng-template>
    </p-menu>
    <button
      [disabled]="isUploadDisabled()"
      [pTooltip]="uploadFileTooltip()"
      (click)="menuCommand.toggle($event)"
      class="group cursor-pointer disabled:cursor-not-allowed"
      tooltipPosition="top"
      tooltipStyleClass="ai-chat-upload-file-tooltip"
    >
      <flx-icon
        name="paperclip"
        class="text-white group-disabled:text-neutral-400"
      />
    </button>

    <input
      #processUpload
      [accept]="allowedProcessFileTypes()"
      [multiple]="isMultipleProcessUploadAllowed()"
      (change)="onFileSelected($event)"
      class="hidden peer"
      type="file"
    />

    <input
      #imageUpload
      [accept]="allowedImageFileTypes()"
      [multiple]="isMultipleImageUploadAllowed()"
      (change)="onFileSelected($event)"
      class="hidden peer"
      type="file"
    />

    <input
      #docUpload
      [accept]="allowedDocumentFileTypes()"
      [multiple]="isMultipleDocumentUploadAllowed()"
      (change)="onFileSelected($event)"
      class="hidden peer"
      type="file"
    />
  }

  <textarea
    #textarea
    [placeholder]="hint()"
    [formControl]="typeControl"
    (keydown)="filterKeyEvents($event)"
    class="w-full mr-6 min-h-6 max-h-[300px] placeholder:px-1 bg-transparent text-sm/6 text-white placeholder-opacity-40 disabled:cursor-not-allowed outline-none"
    flxAutofocus
    cdkTextareaAutosize
  ></textarea>

  <flx-ai-shortcut
    [icons]="submitShortcut"
    [ngClass]="{ 'opacity-30': !canSubmitPrompt() }"
    [pTooltip]="promptInvalidLengthMsg"
    [tooltipDisabled]="!promptInvalidLengthMsg"
    (click)="submitTypeControl()"
    class="group/shortcut absolute right-0 bottom-0 cursor-pointer pointer-events-auto"
    tooltipStyleClass="tooltip-error"
    tooltipPosition="top"
  ></flx-ai-shortcut>
</div>
